// extracted by mini-css-extract-plugin
export default {"measurement":"measurement__aDZ4um2p"};